module.exports = __webpack_public_path__ + "img/45_ProLabel_Inox.052900fe.png";